import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';

/**
 * All Merchandisers list (PD-13923) — backed by the merchandiser entity
 * (/api/merchandisers), not the legacy location-with-type=merchandiser view.
 */
export const allMerchandisersList: ListBuilderList = {
	id: 'default-merchandisers',
	name: 'All Merchandisers',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	columns: createMerchandiserColumns(),
	defaultSortId: 'merchandiser-name',
	sortOrder: 0,
};
